import React from 'react'
import './BoostXpressOverview.scss'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { useNavigate } from 'react-router-dom'
import boostXpressWordmark from 'Assets/Images/Dashboard/overview-pages/boostxpress/boostxpress-wordmark.svg'
import arrowUpGreen from 'Assets/Images/Dashboard/overview-pages/boostxpress/arrow-up-green.svg'
import arrowUpGreen2 from 'Assets/Images/Dashboard/overview-pages/boostxpress/arrow-up-green-2.svg'

type TxStatus = 'Pending' | 'Success'

const BoostXpressOverview = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const name = user?.user?.name ?? 'Admin'

  const tabs: Array<{ label: string; active: boolean; onClick?: () => void }> = [
    { label: 'TradeGrid Boost', active: false, onClick: () => navigate('/general-overview/boost-overview') },
    { label: 'TradersCard', active: false, onClick: () => navigate('/general-overview/traderscard-overview') },
    { label: 'TradeGrid Plus', active: false, onClick: () => navigate('/general-overview/tgplus-overview') },
    { label: 'BoostXpress', active: true },
  ]

  const metrics: Array<{ label: string; value: string; deltaText: string }> = [
    { label: 'Total Number of Active Stations', value: '350', deltaText: '+10 new users' },
    { label: 'Total Number of Users', value: '175', deltaText: '+1 new users' },
    { label: 'Total Vouchers Created', value: '200', deltaText: '+100 new vouchers' },
    { label: 'Number of Transactions', value: '50', deltaText: '+10 transactions' },
    { label: 'Number of Vouchers Used', value: '50', deltaText: '+10 transactions' },
  ]

  const transactions: Array<{
    amount: string
    date: string
    product: string
    status: TxStatus
  }> = [
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Pending' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
  ]

  const usersList: Array<{ name: string; email: string; walletBalance: string }> = [
    { name: 'John Doe', email: 'JD@email.com', walletBalance: '10,000.00' },
    { name: 'John Doe', email: 'JD@email.com', walletBalance: '10,000.00' },
    { name: 'John Doe', email: 'JD@email.com', walletBalance: '10,000.00' },
    { name: 'John Doe', email: 'JD@email.com', walletBalance: '10,000.00' },
    { name: 'John Doe', email: 'JD@email.com', walletBalance: '10,000.00' },
  ]

  return (
    <div className='boostxpress-overview-page'>
      <div className='container boostxpress-overview-page__container'>
        <div className='boostxpress-banner'>
          <div className='boostxpress-banner__content'>
            <div className='boostxpress-banner__welcome'>Welcome Back, {name}</div>
            <div className='boostxpress-banner__subtitle'>Here&apos;s your TradeGrid summary</div>
          </div>
        </div>

        <div className='boostxpress-summary-card'>
          <img src={boostXpressWordmark} className='boostxpress-summary-card__logo' />
          <div className='boostxpress-metrics'>
            {metrics.map((m) => (
              <div className='boostxpress-metric' key={m.label}>
                <div className='boostxpress-metric__label'>{m.label}</div>
                <div className='boostxpress-metric__value'>{m.value}</div>
                <div className='boostxpress-metric__delta'>
                  <img src={arrowUpGreen} className='boostxpress-metric__delta-icon' />
                  <span className='boostxpress-metric__delta-up'>5%</span>
                  <span className='boostxpress-metric__delta-text'>{m.deltaText}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='row g-4 boostxpress-bottom'>
          <div className='col-12 col-lg-7'>
            <div className='boostxpress-tabs'>
              {tabs.map((t) => (
                <button
                  key={t.label}
                  className={`boostxpress-tab ${t.active ? 'boostxpress-tab--active' : ''}`}
                  type='button'
                  onClick={t.onClick}
                >
                  {t.label}
                </button>
              ))}
            </div>

            <div className='boostxpress-section-title'>
              <div className='boostxpress-section-title__left'>Recent Transactions</div>
              <div className='boostxpress-section-title__right'>View all</div>
            </div>

            <div className='boostxpress-table-card'>
              <div className='boostxpress-table-card__head'>
                <div className='boostxpress-table-card__col boostxpress-table-card__col--amount'>
                  Amount
                </div>
                <div className='boostxpress-table-card__col boostxpress-table-card__col--date'>
                  Date
                </div>
                <div className='boostxpress-table-card__col boostxpress-table-card__col--product'>
                  Product
                </div>
                <div className='boostxpress-table-card__col boostxpress-table-card__col--status'>
                  Status
                </div>
              </div>

              <div className='boostxpress-table-card__body'>
                {transactions.map((tx, idx) => (
                  <div
                    className={`boostxpress-tx-row ${idx % 2 === 0 ? 'boostxpress-tx-row--alt' : ''}`}
                    key={`${tx.product}-${idx}`}
                  >
                    <div className='boostxpress-tx-row__col boostxpress-tx-row__col--amount'>
                      {tx.amount}
                    </div>
                    <div className='boostxpress-tx-row__col boostxpress-tx-row__col--date'>
                      {tx.date}
                    </div>
                    <div className='boostxpress-tx-row__col boostxpress-tx-row__col--product'>
                      {tx.product}
                    </div>
                    <div className='boostxpress-tx-row__col boostxpress-tx-row__col--status'>
                      <div
                        className={`boostxpress-status ${
                          tx.status === 'Pending'
                            ? 'boostxpress-status--pending'
                            : 'boostxpress-status--success'
                        }`}
                      >
                        {tx.status}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='col-12 col-lg-5'>
            <div className='boostxpress-users-card mb-4'>
              <div className='boostxpress-users-card__header'>
                <div className='boostxpress-users-card__title'>Recent Users</div>
                <div className='boostxpress-users-card__action'>View all</div>
              </div>

              <div className='boostxpress-users-card__table'>
                <div className='boostxpress-users-card__row boostxpress-users-card__row--head'>
                  <div className='boostxpress-users-card__cell boostxpress-users-card__cell--name'>
                    Name
                  </div>
                  <div className='boostxpress-users-card__cell boostxpress-users-card__cell--email'>
                    Email
                  </div>
                  <div className='boostxpress-users-card__cell boostxpress-users-card__cell--bal'>
                    Wall.bal
                  </div>
                </div>

                {usersList.map((u, idx) => (
                  <div className='boostxpress-users-card__row' key={`${u.email}-${idx}`}>
                    <div className='boostxpress-users-card__cell boostxpress-users-card__cell--name'>
                      {u.name}
                    </div>
                    <div className='boostxpress-users-card__cell boostxpress-users-card__cell--email'>
                      {u.email}
                    </div>
                    <div className='boostxpress-users-card__cell boostxpress-users-card__cell--bal'>
                      {u.walletBalance}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className='boostxpress-stations-card'>
              <div className='boostxpress-stations-card__header'>
                <div className='boostxpress-stations-card__title'>&nbsp;Stations Performance</div>
                <div className='boostxpress-stations-card__action'>View all</div>
              </div>
              <div className='boostxpress-stations-card__value'>NGN500,000</div>
              <div className='boostxpress-stations-card__delta'>
                <img src={arrowUpGreen2} className='boostxpress-stations-card__delta-icon' />
                <span className='boostxpress-stations-card__delta-up'>5%</span>
                <span className='boostxpress-stations-card__delta-text'>+100 new users</span>
              </div>
            </div>
          </div>
        </div>

        <div className='boostxpress-footer'>© 2026 Tradegrid - All rights reserved.</div>
      </div>
    </div>
  )
}

export default BoostXpressOverview

